import React from 'react';
import { Modal, Button, } from "react-bootstrap";
import PersonSearchBox from "presentation/pages/persons/elements/person-search-box";
import CancelButton from "presentation/components/buttons/cancel";


import { PERSON_LOOKUP_OPTION_NONE, entitiesLabel } from 'presentation/model/constants';

class PersonsLookUpModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastValidText: '',
            newRegistration: false,
            personId: null,
            selectedItem: { documentField: null, employee: { id: null, registration: null }, student: { id: null, registration: null } }
        };

    }


    onFieldChange = (fieldValue) => {
        if (fieldValue != PERSON_LOOKUP_OPTION_NONE) {
            this.setState({ lastValidText: fieldValue, personId: null });
        }
    }

    onSelectItem = (selectedItem) => {

        this.setState({ ...this.state, selectedItem: selectedItem }, () => {
            if (!selectedItem) {
                this.setState({ ...this.state, lastValidText: '', newRegistration: false, personId: null });
            } else {
                if (selectedItem.name == PERSON_LOOKUP_OPTION_NONE) {
                    this.setState({ ...this.state, newRegistration: true, personId: null });
                } else {
                    this.setState({ ...this.state, newRegistration: false, personId: selectedItem.id });
                }
            }
        });
    }

    onSubmit = async () => {
        let { history, baseRedirectUrl } = this.props;
        let { personId, lastValidText, newRegistration, selectedItem } = this.state;
        history.push({
            pathname: baseRedirectUrl,
            state: {
                personId: personId,
                personEntity: selectedItem,
                newRegistration: newRegistration,
                personName: lastValidText
            }
        });

    };

    checkEntityDuplicate = (searchEntity, entityData) => {
        var output = false;

        switch (searchEntity) {
            case 'student': {
                if (entityData && entityData.student && entityData.student.id) {
                    output = true;
                }
            } break;
            case 'employee': {
                if (entityData && entityData.employee && entityData.employee.id) {
                    output = true;
                }
            } break;
        }

        return output;
    }

    render() {
        let { show, onClose, modalTitle, avoidDuplicate } = this.props;
        let { loading, lastValidText, newRegistration, selectedItem, personId } = this.state;
        const { onSubmit, onSelectItem, onFieldChange, checkEntityDuplicate } = this;

        let blocked = checkEntityDuplicate(avoidDuplicate, selectedItem);

        return (
            <Modal backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle || "Buscando cadastro de pessoas"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PersonSearchBox onSelect={onSelectItem} onChange={onFieldChange} />
                    {newRegistration == true &&
                        (
                            <>
                                <br />
                                <p>Sem problemas! Clique em prosseguir e vamos cadastrar o(a) <strong>{lastValidText}</strong></p>
                            </>
                        )
                    }
                    {selectedItem != null && selectedItem.id != null &&
                        (
                            <>
                                {blocked == true && (
                                    <>
                                        <br />
                                        <p>Já existe um cadastro de {entitiesLabel[avoidDuplicate]}.</p>
                                        <p><strong>Id: {selectedItem[avoidDuplicate].id || ""}</strong></p>
                                        <p><strong>Matrícula: {selectedItem[avoidDuplicate].registration || ""}</strong></p>
                                    </>
                                )}
                                {blocked == false && (
                                    <>
                                        <br />
                                        <p>Documento: <strong> {selectedItem.documentField || " - Não informado -"}</strong></p>
                                        {selectedItem.student && selectedItem.student.id && (
                                            <>
                                                <p>Identificação como aluno: <strong> {selectedItem.student.id || " - Não informado -"}</strong></p>
                                                <p>Matricula de aluno: <strong> {selectedItem.student.registration || " - Não informado -"}</strong></p>
                                            </>
                                        )}
                                        {selectedItem.employee && selectedItem.employee.id && (
                                            <>
                                                <p>Identificação como colaborador: <strong> {selectedItem.employee.id || " - Não informado -"}</strong></p>
                                                <p>Matricula de colaborador: <strong> {selectedItem.employee.registration || " - Não informado -"}</strong></p>
                                            </>
                                        )}
                                        <p>
                                            Tudo certo?

                                        </p>

                                        <p>Se sim, clique em <strong><em>Prosseguir</em></strong>.</p>
                                        <p>Se não,</p>
                                        <ul>
                                            <li>tente digitar um nome mais completo, ou</li>
                                            <li>É um cadastro totalmetne novo? Digite o nome que deseja cadastrar e escolha a opção "<em>{PERSON_LOOKUP_OPTION_NONE}</em>" na listagem que aparecer...</li>
                                        </ul>
                                    </>
                                )}
                            </>
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <Button disabled={(!personId && !newRegistration) || blocked} variant="success" onClick={() => onSubmit()}>
                        Prosseguir
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
}

export default PersonsLookUpModal;